import PageTitle from "components/PageTitle/PageTitle";
import PageFrame from "components/Panels/PageFrame";
import { getNowServiceState } from "pages/NoticeBoard/model/board_row";
import { useParams } from "react-router-dom";
import StaffDMUpdateWrapper from "./StaffDMUpdateWrapper";
const StaffDMUpdateService = () => {
  const params = useParams();
  const nowService = "전달사항";
  return (
    <div>
      <PageFrame
        children={
          <div>
            <PageTitle titleText="전달사항" />
            <StaffDMUpdateWrapper
              nowService={getNowServiceState(nowService)}
              postId={params.postId}
            />
          </div>
        }
      />
    </div>
  );
};

export default StaffDMUpdateService;
